//通知
import request from './request'

//通知事项
export function _notifyList(data = {}) {
    const config = Object.assign(data, {
      method: 'get',
      url: '/admin/notify/index',
    })
    return request(config)
}

//获取未通知的数量
export function _getNewTotal(data = {}) {
  const config = Object.assign(data, {
    method: 'get',
    url: '/admin/notify/new-total',
  })
  return request(config)
}

//将未读通知改为已读的接口
export function _clearNewTotal(data = {}) {
  const config = Object.assign(data, {
    method: 'get',
    url: '/admin/notify/read',
  })
  return request(config)
}
